<template>
  <div>
    <div class="grade__item mb-4" v-for="(g, i) in grades" :key="i + key">
      <div class="input-group">
        <label class="d-flex justify-content-between w-100 mb-1" for="">
          Мінімальна кількість балів <span> #{{ i + 1 }}</span>
        </label>
        <b-form-input type="number" v-model="grades[i].min_points" />
      </div>
      <div class="input-group mt-2">
        <label class="d-block w-100 mb-1" for=""> Опис результату </label>
        <b-form-textarea v-model="grades[i].description"> </b-form-textarea>
      </div>
      <hr />
    </div>
    <div class="d-flex justify-content-end pt-2">
      <b-button @click="addStep" variant="link"> + Додати крок </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["gradesInput", "maxPoints"],
  data() {
    return {
      key: 1,
      new_grade: {
        min_points: 0,
        description: "",
        tags: [],
      },
      grades: [],
    };
  },
  watch: {
    gradesInput: {
      handler() {
        if (this.gradesInput) {
          this.grades = this.gradesInput;
          this.key++;
        }
      },
    },
  },
  methods: {
    addStep() {
      let grade = Object.assign({}, this.new_grade);

      this.grades.push(grade);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.grade {
  &__item {
  }
}
</style>
